import { render } from "./ShowImage.vue?vue&type=template&id=040b7802&scoped=true"
import script from "./ShowImage.vue?vue&type=script&lang=js"
export * from "./ShowImage.vue?vue&type=script&lang=js"

import "./ShowImage.vue?vue&type=style&index=0&id=040b7802&scoped=true&lang=css"

import exportComponent from "/var/www/html/doc_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040b7802"]])

export default __exports__